import { action, extendObservable } from 'mobx';
import FormService from '../../../core/services/FormService';
import { isRequired } from '../../../core/validations';
import FetchService from '../../../core/services/FetchService';
import NotificationService from '../../../core/services/NotificationService';
import UnitListService from './UnitListService';
import { Roles } from '../../../core/util';

class AddExistingUnitFormDialogService {
  form = new FormService();
  submit = new FetchService();
  fetch = new FetchService();

  constructor() {
    extendObservable(this, {
      isOpen: false,
    });
    this.form.validations = {
      unit: [isRequired],
      group: [isRequired],
      order: [isRequired],
    };
  }

  open = action((moduleId) => {
    this.form.setInitialValues({});
    this.form.reset();

    this.form.setValue('module', moduleId);
    if ([Roles.DISTRIBUTOR_MANAGER, Roles.DISTRIBUTOR_CONTENT_ADMIN].includes(localStorage.role)) {
      this.form.setValue('distributor', localStorage.distributor);
    }

    this.isOpen = true;
  });

  handleSave = action(() => {
    this.form.submitted = true;
    if (this.form.errors) {
      return;
    }

    this.submit
      .fetch({
        url: `/modules/${this.form.getValue('module')}/units/${this.form.getValue('unit')}/link`,
        method: 'patch',
        body: {
          order: this.form.getValue('order'),
          group: this.form.getValue('group'),
        },
      })
      .then(() => {
        if (this.submit.data) {
          this.isOpen = false;
          NotificationService.addNotification('Unit added successfully.', 'success');
          UnitListService.load();
        }
        if (this.submit.error) {
          NotificationService.addNotification('Error adding unit.', 'error');
        }
      });
  });

  handleCancel = action(() => {
    this.isOpen = false;
  });
}
const addExistingUnitFormDialogService = new AddExistingUnitFormDialogService();

export default addExistingUnitFormDialogService;
